import { Mui } from "@osu/react-ui";
import { Fragment } from "react";

function Deadline({ sx, label, description, descriptionListItem }) {
  return <Fragment>
    <Mui.Typography sx={sx} variant="subtitle2" component={descriptionListItem ? "dt" : undefined}>
      {label}
    </Mui.Typography>
    <Mui.Typography component={descriptionListItem ? "dd" : undefined}>{description}</Mui.Typography>
  </Fragment>;
}

export default Deadline;
